let config = {
    instanceId: 'prod',
    redisHost: '127.0.0.1',
    redisPort: 6379,
    wsHost: 'https://medvedmarket.com',
    wsPort: 1986,
    secure: true,
    sslCertificateKey: '/home/admin/conf/web/ssl.medvedmarket.com.key',
    sslCertificatePath: '/home/admin/conf/web/ssl.medvedmarket.com.crt'
};

module.exports = config;
